import React from "react";
import { TeamAdminScreenProp } from "./TeamAdmin";
import { TeamWhitelistUsers } from "./TeamWhitelistUsers";

export const TeamAdminWhitelistUser = (
  props: TeamAdminScreenProp<"TeamAdminWhitelistUser">
) => {
  return (
    <TeamWhitelistUsers
      goBack={() => props.navigation.goBack()}
      teamId={props.route.params.teamId}
      setOptions={props.navigation.setOptions}
    />
  );
};
